import * as actions from './actions';
import reducers from './reducer';

export const Notification = { actions, reducers };
export { NotificationState } from './reducer';
